import React from "react";
import { useLocation } from "react-router-dom";
import "./Layout.scss";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import ContactBar from "components/contact-bar/ContactBar";
import ScrollToFooter from "components/scroll-to-footer/ScrollToFooter";

const Layout = ({ children }) => {
  const location = useLocation();
  const showScrollToFooter = location.pathname === "/catalogue";

  return (
    <div className="layout">
      <Header />
      <main className="layout__content">{children}</main>
      <ContactBar />
      {showScrollToFooter && <ScrollToFooter />}
      <Footer />
    </div>
  );
};

export default Layout;
